import React from "react";

const CloseIcon = () => (
  <img className="icon" alt={"close"} src={"./close.svg"} />
);

export default CloseIcon;
